import { useNavigate } from "react-router-dom";

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div
      style={{
        textAlign: "center",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        fontFamily: "var(--font-title)",
      }}
    >
      <div>
        <h1>404 - Page Not Found</h1>
        <p>The page you are looking for doesn’t exist or the link is invalid.</p>
        <button
          onClick={() => navigate("/", { replace: true })}
          style={{
            marginTop: "20px",
            padding: "10px 20px",
            backgroundColor: "#ff3100",
            color: "white",
            border: "none",
            borderRadius: "5px",
            cursor: "pointer",
          }}
        >
          Go to Login
        </button>
      </div>
    </div>
  );
};

export default NotFound;
